import { render } from "./ViewOrganizationGeneralInformation.vue?vue&type=template&id=775f4d2a&scoped=true"
import script from "./ViewOrganizationGeneralInformation.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationGeneralInformation.vue?vue&type=script&lang=js"

import "./general-info.scss?vue&type=style&index=0&id=775f4d2a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775f4d2a"]])

export default __exports__